import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    currencies: [],
    currenciesCount: 0,
    currency: {},
    currencySave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getCurrencies(state) {
      return state.currencies
    },
    getCurrenciesCount(state) {
      return state.currenciesCount
    },
    getCurrency(state) {
      return state.currency
    },
    getCurrencySaveStatus(state) {
      return state.currencySave
    },
  },
  mutations: {
    CURRENCIES_LIST(state, data) {
      state.currencies = data
    },
    CURRENCY_VIEW(state, data) {
      state.currency = data
    },
    CURRENCIES_COUNT(state, data) {
      state.currenciesCount = data
    },
    CURRENCY_SAVE(state, data) {
      state.currencySave = data
    },
  },
  actions: {
    currenciesList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/defines/currencies/getData', data)
        .then(response => {
          commit('CURRENCIES_LIST', response.data.data)
          commit('CURRENCIES_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    currencyView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'currencies.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/defines/currencies/getData', data)
        .then(response => {
          commit('CURRENCY_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    currencySave({ commit }, postData) {
      const data = JSON.stringify({ formData: postData })
      axiosIns
        .post('/defines/currencies/saveData', data)
        .then(response => {
          commit('CURRENCY_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
